import React from 'react';

const COLOR_MAP = {
  dark_green:  { bg: '#166534', text: '#4ade80',  dot: '#4ade80'  },
  green:       { bg: '#14532d', text: '#86efac',  dot: '#86efac'  },
  light_green: { bg: '#1a2e05', text: '#a3e635',  dot: '#a3e635'  },
  yellow:      { bg: '#422006', text: '#fbbf24',  dot: '#fbbf24'  },
  orange:      { bg: '#431407', text: '#fb923c',  dot: '#fb923c'  },
  red:         { bg: '#450a0a', text: '#f87171',  dot: '#f87171'  },
};

const LEGEND = [
  { key: 'dark_green',  label: 'Excellent' },
  { key: 'green',       label: 'Good'      },
  { key: 'light_green', label: 'Decent'    },
  { key: 'yellow',      label: 'Fair'      },
  { key: 'orange',      label: 'Poor'      },
  { key: 'red',         label: 'Bad'       },
];

function pad(n) { return String(n).padStart(2, '0'); }

export default function NutritionCalendar({ year, month, logs, onSelectDay, onChangeMonth }) {
  const logByDate = {};
  logs.forEach((log) => { logByDate[log.date] = log; });

  const firstDay     = new Date(year, month - 1, 1);
  const daysInMonth  = new Date(year, month, 0).getDate();
  const startWeekday = firstDay.getDay();

  const cells = [];
  for (let i = 0; i < startWeekday; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  const monthName = firstDay.toLocaleString('default', { month: 'long' });
  const todayStr  = new Date().toISOString().slice(0, 10);

  return (
    <div className="cal-wrap">

      {/* ── Month Header ── */}
      <div className="cal-header">
        <button
          className="cal-nav-btn"
          onClick={() => onChangeMonth(-1)}
          aria-label="Previous month"
        >
          ‹
        </button>

        <div style={{ textAlign: 'center' }}>
          <h2 className="cal-month-title">{monthName}</h2>
          <div className="cal-year">{year}</div>
        </div>

        <button
          className="cal-nav-btn"
          onClick={() => onChangeMonth(1)}
          aria-label="Next month"
        >
          ›
        </button>
      </div>

      {/* ── Weekday Headers ── */}
      <div className="cal-weekdays">
        {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((d, i) => (
          <div key={i} className="cal-weekday">{d}</div>
        ))}
      </div>

      {/* ── Day Cells ── */}
      <div className="cal-grid">
        {cells.map((day, idx) => {
          if (!day) return <div key={idx} />;

          const dateStr  = `${year}-${pad(month)}-${pad(day)}`;
          const log      = logByDate[dateStr];
          const colorSet = log ? COLOR_MAP[log.colorRating] : null;
          const isToday  = dateStr === todayStr;

          return (
            <button
              key={idx}
              className="cal-day-btn"
              onClick={() => onSelectDay(dateStr)}
              title={log
                ? `${log.totalCalories} cal — Score: ${log.healthScore}/100`
                : dateStr}
              style={{
                border: isToday
                  ? '2px solid #a3e635'
                  : `1px solid ${colorSet ? `${colorSet.dot}30` : 'rgba(255,255,255,0.06)'}`,
                background: colorSet
                  ? colorSet.bg
                  : isToday ? 'rgba(163,230,53,0.06)' : 'rgba(255,255,255,0.025)',
                color: colorSet
                  ? colorSet.text
                  : isToday ? '#a3e635' : 'rgba(241,245,249,0.55)',
                fontWeight: isToday || colorSet ? 700 : 500,
                boxShadow: isToday ? '0 0 12px rgba(163,230,53,0.18)' : 'none',
              }}
            >
              <span>{day}</span>
              {log && (
                <span className="cal-cal-tag">{log.totalCalories}</span>
              )}
            </button>
          );
        })}
      </div>

      {/* ── Legend ── */}
      <div className="cal-legend">
        {LEGEND.map(({ key, label }) => (
          <div key={key} className="cal-legend-item">
            <span
              className="cal-legend-dot"
              style={{ background: COLOR_MAP[key].dot }}
            />
            {label}
          </div>
        ))}
      </div>
    </div>
  );
}
